import { memo } from "react";
import { useDispatch } from "react-redux";
import $ from "jquery";

import { deleteUser } from "../../../../../../../actions/customer";

function DeleteButton({ id }) {
  const dispatch = useDispatch();

  const deleteUserById = () => {
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this customer?",
      type: "red",
      buttons: {
        ok: {
          text: "Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            deleteUser(id, dispatch);
          },
        },
        cancel: function () {},
      },
    });
  };
  return (
    <button
      className="btn btn-danger btn-sm mr-1"
      onClick={() => deleteUserById()}
    >
      Delete
    </button>
  );
}

export default memo(DeleteButton);
